// extracted by mini-css-extract-plugin
module.exports = {"av-hover":"_2ZTeEE"};